import React, { useState, useEffect, useContext } from 'react';
import * as fkn from "../../lib/fkn";
import * as net from "../../lib/net";
import PdfRpDlg from "../../pos/eko/fkn/pdf_rp_dlg";
import Dt_Cal from "../../lib/ui/dt_cal";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";

class Pms_Bokat extends React.Component {
  constructor(props, context) {
    super(props);

    this.webStore = props.store;
    this.state = { pgid: 11, tra: [] };
    this.state.fdat = new Date();
    this.state.tdat = new Date();
    this.state.fkn = "";
    this.state.bsa = [];
    //context.posrend = this;
    let cdat = new Date();
    let formatted_date = cdat.getFullYear() + "-" + (cdat.getMonth() + 1) + "-" + cdat.getDate();
    this.state.today = formatted_date;
    this.state.fdatum = formatted_date;
    this.state.tdatum = formatted_date;
    this.state.pdf = 0;
    this.state.pdf_content = null;
  }
  componentDidUpdate() {
    let value = this.context;
    /* ... */
  }
  componentWillUnmount() {
    let value = this.context;
    /* ... */
  }
  componentDidMount() {
    //this.props.fetchWells()
    //  .then(res => this.setState({ wells: res.wells }) )
    //this.gsts();
  }

  body_style() {
      var css = {};
      css.height = window.innerHeight - 280;
      return css;
  }
  tb_style() {
      var css = {};
      css.height = window.innerHeight - 250;
      return css;
  }
  onUnitChange(e) {
        this.setState({unit: e.value});
  }
  change_fdat(e) {
    //let cdat = this.state.seldate;
      if(e.value == null) return;

    let cdat = e.value;
    let formatted_date = cdat.getFullYear() + "-" + (cdat.getMonth() + 1).toString().tonum(2) + "-" + cdat.getDate().toString().tonum(2);
    this.setState({fdat: e.value});
    this.setState({fdatum: formatted_date});
    this.setState({tra: [] });
  }
  change_tdat(e) {
    //let cdat = this.state.seldate;
      if(e.value == null) return;
    let cdat = e.value;
    let formatted_date = cdat.getFullYear() + "-" + (cdat.getMonth() + 1).toString().tonum(2) + "-" + cdat.getDate().toString().tonum(2);
    this.setState({tdat: e.value});
    this.setState({tdatum: formatted_date});
    this.setState({tra: [] });
  }
  change_fkn(e) {
    //let cdat = this.state.seldate;
    //alert(JSON.stringify(e));
    let fkn = e.target.value;
    this.setState({fkn: fkn});
    this.setState({tra: [], tsa: [], tta: [] });
  }

  dt_fkn() {
    var self = this;
    var datum = this.state.datum;
    var today = this.state.today;

    if(this.state.fkn == "TRS") this.gsts();
    else if(this.state.fkn == "TOT") this.gsts();
    else this.gsts();
  }

  bok() {
    var self = this;
    var prm = {};
    prm.req = "red.red_gst.bok_list";
    //prm.fdat = this.state.fdatum;
    //prm.tdat = this.state.tdatum;
    prm.datum = "202011002";
    prm.fdat = "202011002";
    prm.tdat = "202011003";

    //gda.wndLoading("Hämtar");
    //net.sio_req(prm)
    net.sid_req(prm)
    .then(function(ret){
        //alert(JSON.stringify(ret));

        if(ret.ok != "000") {
            return;
        }
        self.setState({bsa: ret.rca });
        //toastr.success("OK", "SAPI");
    })
    .catch(function(e){
        var txt = JSON.stringify(e);
        //gda.wndError(txt);
    });
    }
  bok_rp() {
    var self = this;
    var prm = {};
    prm.req = "red.red_gst.bok_rp";
    //prm.fdat = this.state.fdatum;
    //prm.tdat = this.state.tdatum;
    prm.datum = "202011002";
    prm.fdat = "202011002";
    prm.tdat = "202011003";

    //gda.wndLoading("Hämtar");
    //net.sio_req(prm)
    net.sid_req(prm)
    .then(function(ret){
        //alert(JSON.stringify(ret));

        if(ret.ok != "000") {
            return;
        }
        self.setState({pdf: 1, pdf_content: ret.pdf });
        //toastr.success("OK", "SAPI");
    })
    .catch(function(e){
        var txt = JSON.stringify(e);
        //gda.wndError(txt);
    });
    }

  render() {
    return (
    <div className="web-app" style={{margin: "0px", padding: "5px 10px"}}>
    <h3>Hotell Bokat</h3>

    <div className="flex-row flex-space-between">
        <div className="flex-row">
            <div className="flex-row">
                <div className="dt-btn-01" onClick={() => this.subday() } ><FontAwesomeIcon icon="minus" size="1x" /></div>
                <Dt_Cal dts={this.state.dts} rp="1" ref={this.dt_dt} getValue={(e)=> this.dt_dat(e)} />
                <div className="dt-btn-01" onClick={() => this.addday() } ><FontAwesomeIcon icon="plus" size="1x" /></div>
            </div>
            <div className="flex-row">
                <div className="dt-btn-01" onClick={() => this.subday() } ><FontAwesomeIcon icon="minus" size="1x" /></div>
                <Dt_Cal dts={this.state.dts} rp="1" ref={this.dt_dt} getValue={(e)=> this.dt_dat(e)} />
                <div className="dt-btn-01" onClick={() => this.addday() } ><FontAwesomeIcon icon="plus" size="1x" /></div>
            </div>
        </div>
        <button className="btn btn-hw-blue w150 ripple" onClick={() => this.bok_rp() } aria-label="System" >
            Rapport
        </button>
        <button className="btn btn-hw-blue w150 ripple" onClick={() => this.bok() } aria-label="System" >
            Visa
        </button>
    </div>
    <div className="divider">
    </div>

        <div className="web-row">
            <table className="table table-bordered table-hover tb fixed_header">
                <thead>
                <tr>
                    <th>Ankomst</th>
                    <th>Avresa</th>
                    <th>Boknr</th>
                    <th>HBoknr</th>
                    <th>Rum</th>
                    <th>Pers</th>
                    <th>Namn</th>
                    <th>Anm 1</th>
                    <th>Anm 2</th>
                    <th>Telefon</th>
                    <th>Epost</th>
                    <th>Grupp</th>
                    <th>Status</th>
                </tr>
                </thead>
                <tbody style={ this.tb_style() }>
                { this.state.bsa.map((row, key) =>
                    <tr id={ row.bok00.b0boknr } ng-dblclick="trans_open(row);">
                        <td>{ row.bok00.b0ankdat.cdidate() }</td>
                        <td>{ row.bok00.b0avrdat.cdidate() }</td>
                        <td>{ row.bok00.b0boknr }</td>
                        <td>{ row.bok00.b0hboknr }</td>
                        <td>{ row.bok00.b0rumant }</td>
                        <td>{ row.bok00.b0persant }</td>
                        <td>{ row.bok00.b0namn }</td>
                        <td>{ row.bok02.b2anm1 }</td>
                        <td>{ row.bok02.b2anm2 }</td>
                        <td>{ row.bok02.b2tel }</td>
                        <td>{ row.bok01.b1adr1 }</td>
                        <td>{ row.bok00.b0grupp }</td>
                        <td>{ row.bok00.b0status }</td>
                    </tr>
                )}
                </tbody>
            </table>
        </div>
        <PdfRpDlg show={this.state.pdf} ctx={this} backdrop={true}/>
    </div>
  );
}
}
export default Pms_Bokat;
